import { Pipe, PipeTransform } from '@angular/core';

import { QuestionStateService } from '@core/services';

import { QuestionField, QuestionType } from '@/tax-detail/models';

import { InternalFieldEqualsPipe } from './internal-field-equals.pipe';

@Pipe({
    name: 'fieldEquals',
    standalone: false,
})
export class FieldEqualsPipe implements PipeTransform {
    constructor(private stateService: QuestionStateService) {}

    transform(field: QuestionField, internalValue: any, externalValue: any): boolean {
        if (!field.syncableToSilverfin) {
            return true;
        }
        if (field.type === QuestionType.SelectDependent) {
            const internalUid = this.stateService
                .getCurrentFieldState(field.selectDependentDisplayField!)
                .find((state) => state.groupId === internalValue)?.groupUid;
            const externalUid = this.stateService
                .getCurrentFieldStateExternal(field.selectDependentDisplayField!)
                .find((state) => state.groupId === externalValue)?.groupUid;
            return internalUid !== undefined && externalUid !== undefined && internalUid === externalUid;
        }
        return new InternalFieldEqualsPipe().transform(field, internalValue, externalValue);
    }
}
